import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-5 text-right align-self-end" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = {
  key: 0,
  class: "container"
}
const _hoisted_7 = {
  class: "row",
  style: {"margin":"0","height":"100%"}
}
const _hoisted_8 = {
  class: "col-sm-3 bg-color-gray4",
  style: {"height":"100%"}
}
const _hoisted_9 = { style: {"margin":"20px 5px"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "fa fa-exclamation-triangle fa-lg fg-color-red"
}
const _hoisted_12 = {
  key: 1,
  class: "fa fa-filter fa-lg"
}
const _hoisted_13 = {
  key: 2,
  class: "fa fa-list fa-lg"
}
const _hoisted_14 = { class: "col-sm-9" }
const _hoisted_15 = {
  key: 0,
  style: {"margin":"10px"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = {
  class: "col-sm-6",
  style: {"text-align":"right"}
}
const _hoisted_20 = { class: "dropdown d-inline-block" }
const _hoisted_21 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "card-header" }
const _hoisted_29 = { class: "dropdown" }
const _hoisted_30 = {
  key: 0,
  class: "mr-1"
}
const _hoisted_31 = {
  key: 1,
  class: "mr-1"
}
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = {
  key: 0,
  class: "fa-regular fa-square-check"
}
const _hoisted_34 = {
  key: 1,
  class: "fa-regular fa-square"
}
const _hoisted_35 = {
  key: 0,
  class: "fa-regular fa-square-check"
}
const _hoisted_36 = {
  key: 1,
  class: "fa-regular fa-square"
}
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = {
  class: "dropdown",
  style: {"display":"inline-block"}
}
const _hoisted_39 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_40 = {
  key: 3,
  class: "table table-striped"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 4,
  class: "table table-striped"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativesViewDeleterDialog = _resolveComponent("AlternativesViewDeleterDialog")!
  const _component_AlternativesViewDependenciesDialog = _resolveComponent("AlternativesViewDependenciesDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_AttributeFilter = _resolveComponent("AttributeFilter")!
  const _component_StatusFilter = _resolveComponent("StatusFilter")!
  const _component_ListFilter = _resolveComponent("ListFilter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlternativesViewDeleterDialog, {
      viewModel: _ctx.alternativesViewDeleterDialog,
      onDeleteList: _ctx.handleDeleteAlternativesViewCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteList"]),
    _createVNode(_component_AlternativesViewDependenciesDialog, { viewModel: _ctx.alternativesViewDependenciesDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-lg-7" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Lists"),
          _createElementVNode("p", { class: "text-muted mb-0" }, "Build custom lists to structure and analyse your portfolio by combining Kanban Statuses, Attribute values and existing lists.")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[30] || (_cache[30] = _createElementVNode("button", {
              class: "btn btn-success",
              style: {"padding":"0.7em 2em"},
              type: "button",
              "data-toggle": "dropdown"
            }, " Create list ", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createStaticList && _ctx.createStaticList(...args)))
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("strong", null, "Static", -1 /* CACHED */),
                _createElementVNode("br", null, null, -1 /* CACHED */),
                _createTextVNode(" Manage list items manually ", -1 /* CACHED */)
              ]))]),
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createActiveList && _ctx.createActiveList(...args)))
              }, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("strong", null, "Active", -1 /* CACHED */),
                _createElementVNode("br", null, null, -1 /* CACHED */),
                _createTextVNode("Dynamic list based on your conditions", -1 /* CACHED */)
              ]))])
            ])
          ])
        ])
      ])
    ]),
    _cache[49] || (_cache[49] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listSearchPhrase) = $event)),
                  class: "form-control",
                  placeholder: "Type to search..."
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.listSearchPhrase]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listsView, (l) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    class: "list-group",
                    key: l.Id
                  }, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["list-group-item pointer", {'active' : _ctx.SelectedView?.Id === l.Id }]),
                      onClick: ($event: any) => (_ctx.SelectView(l.Id))
                    }, [
                      _createElementVNode("span", null, [
                        (!l.IsValid)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                          : _createCommentVNode("v-if", true),
                        (l.IsValid && !l.IsStatic)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                          : _createCommentVNode("v-if", true),
                        (l.IsValid && l.IsStatic)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(l.Name), 1 /* TEXT */)
                      ])
                    ], 10 /* CLASS, PROPS */, _hoisted_10)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.SelectedView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_ctx.IsEdited === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("h4", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.SelectedView.Name), 1 /* TEXT */),
                                _createElementVNode("small", null, "(" + _toDisplayString(_ctx.SelectedView.Included?.length) + ")", 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _cache[33] || (_cache[33] = _createElementVNode("a", {
                                  class: "text-dark dropdown-toggle",
                                  "data-toggle": "dropdown"
                                }, " Actions ", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startListEditing && _ctx.startListEditing(...args)))
                                  }, "Edit"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cloneList && _ctx.cloneList(...args)))
                                  }, "Clone"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cloneAsStaticList && _ctx.cloneAsStaticList(...args)))
                                  }, "Save as static list"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showListDependenciesViewer && _ctx.showListDependenciesViewer(...args)))
                                  }, "View dependencies"),
                                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showListDeleter && _ctx.showListDeleter(...args)))
                                  }, "Delete")
                                ])
                              ])
                            ])
                          ]),
                          _cache[34] || (_cache[34] = _createElementVNode("hr", null, null, -1 /* CACHED */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.IsEdited === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "row" }, [
                            _createElementVNode("div", { class: "col-sm-3" }, [
                              _createElementVNode("strong", null, "List name:")
                            ]),
                            _createElementVNode("div", { class: "col-sm-6" })
                          ], -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.SelectedView.Name) = $event)),
                                class: "form-control"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _ctx.SelectedView.Name,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("button", {
                                role: "button",
                                class: "btn btn-primary mr-1",
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.SaveCommand && _ctx.SaveCommand(...args)))
                              }, "Save"),
                              _createElementVNode("button", {
                                role: "button",
                                class: "btn btn-outline-secondary",
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelListEditing && _ctx.cancelListEditing(...args)))
                              }, "Cancel")
                            ])
                          ]),
                          _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1 /* CACHED */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.IsEdited && !_ctx.SelectedView.IsStatic)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                (_ctx.filter.Type === 'And')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Include when all of conditions are met"))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.filter.Type === 'Or')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Include when any of conditions are met"))
                                  : _createCommentVNode("v-if", true),
                                _cache[40] || (_cache[40] = _createElementVNode("a", {
                                  class: "fa fa-cog pointer",
                                  "data-toggle": "dropdown"
                                }, null, -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_32, [
                                  _cache[39] || (_cache[39] = _createElementVNode("div", { class: "dropdown-header" }, "Include when:", -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filter.Type = 'And'))
                                  }, [
                                    (_ctx.filter.Type === 'And')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                                      : _createCommentVNode("v-if", true),
                                    (_ctx.filter.Type === 'Or')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                                      : _createCommentVNode("v-if", true),
                                    _cache[37] || (_cache[37] = _createTextVNode(" all of conditions are met ", -1 /* CACHED */))
                                  ]),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filter.Type = 'Or'))
                                  }, [
                                    (_ctx.filter.Type === 'Or')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                                      : _createCommentVNode("v-if", true),
                                    (_ctx.filter.Type === 'And')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                                      : _createCommentVNode("v-if", true),
                                    _cache[38] || (_cache[38] = _createTextVNode(" any of conditions are met ", -1 /* CACHED */))
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.Filters, (f) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  (f.IsPropertyFilter)
                                    ? (_openBlock(), _createBlock(_component_AttributeFilter, {
                                        key: 0,
                                        propRm: f,
                                        propAttributes: _ctx.rm.Attributes,
                                        onDeleteFilter: _ctx.deleteFilter
                                      }, null, 8 /* PROPS */, ["propRm", "propAttributes", "onDeleteFilter"]))
                                    : _createCommentVNode("v-if", true),
                                  (f.IsStatusFilter)
                                    ? (_openBlock(), _createBlock(_component_StatusFilter, {
                                        key: 1,
                                        propRm: f,
                                        propStatuses: _ctx.rm.Statuses,
                                        onDeleteFilter: _ctx.deleteFilter
                                      }, null, 8 /* PROPS */, ["propRm", "propStatuses", "onDeleteFilter"]))
                                    : _createCommentVNode("v-if", true),
                                  (f.IsMemberFilter)
                                    ? (_openBlock(), _createBlock(_component_ListFilter, {
                                        key: 2,
                                        propRm: f,
                                        propViews: _ctx.rm.Views,
                                        onDeleteFilter: _ctx.deleteFilter
                                      }, null, 8 /* PROPS */, ["propRm", "propViews", "onDeleteFilter"]))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */)),
                              _createElementVNode("div", _hoisted_38, [
                                _cache[46] || (_cache[46] = _createElementVNode("a", {
                                  class: "pointer",
                                  style: {"font-size":"14px"},
                                  "data-toggle": "dropdown"
                                }, [
                                  _createElementVNode("span", { class: "fa fa-plus" }),
                                  _createTextVNode(" Add condition ")
                                ], -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_39, [
                                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "dropdown-header" }, "Status:", -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addFilter('StatusIn')))
                                  }, "is one of"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addFilter('StatusNotIn')))
                                  }, "is none of"),
                                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "dropdown-header" }, "Attribute value:", -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addFilter('PropertyEq')))
                                  }, "equal to"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addFilter('PropertyNotEq')))
                                  }, "NOT equal to"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addFilter('PropertyLt')))
                                  }, "is less than"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addFilter('PropertyLte')))
                                  }, "is less than or equal to"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addFilter('PropertyGt')))
                                  }, "is greater than"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addFilter('PropertyGte')))
                                  }, "is greater than or equal to"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addFilter('PropertyIsKnown')))
                                  }, "any value"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addFilter('PropertyIsUnknown')))
                                  }, "no value"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addFilter('PropertyContains')))
                                  }, "contains"),
                                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "dropdown-header" }, "List:", -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addFilter('MemberOf')))
                                  }, "is included"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.addFilter('NotMemberOf')))
                                  }, "is NOT included")
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("input", {
                      type: "search",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.alternativesSearchPhrase) = $event)),
                      class: "form-control",
                      placeholder: "Type to search by name..."
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.alternativesSearchPhrase]
                    ]),
                    (_ctx.IsEdited && _ctx.SelectedView.IsStatic)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_40, [
                          _cache[47] || (_cache[47] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th"),
                              _createElementVNode("th", null, "Name"),
                              _createElementVNode("th", null, "Description")
                            ])
                          ], -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesView, (a) => {
                            return (_openBlock(), _createElementBlock("tbody", {
                              key: a.Id
                            }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, [
                                  (_ctx.IsEditedIncluded(a.AlternativeId))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.Exclude(a.AlternativeId)),
                                        class: "fa-regular fa-square-check"
                                      }, null, 8 /* PROPS */, _hoisted_41))
                                    : _createCommentVNode("v-if", true),
                                  (!_ctx.IsEditedIncluded(a.AlternativeId))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.Include(a.AlternativeId)),
                                        class: "fa-regular fa-square"
                                      }, null, 8 /* PROPS */, _hoisted_42))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(a.Name), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString(a.Description), 1 /* TEXT */)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!_ctx.IsEdited)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
                          _cache[48] || (_cache[48] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Name"),
                              _createElementVNode("th", null, "Description")
                            ])
                          ], -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesView, (a) => {
                            return (_openBlock(), _createElementBlock("tbody", {
                              key: a.Id
                            }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(a.Name), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString(a.Description), 1 /* TEXT */)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}